import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
// const adminApi = "https://openapi.cheyun.com/";
//销量排行————总销量
export const salesTotal = (params={}) => {
  const url = adminApi  + 'SalesRank/salesTotal'
  return http.fetchGet(url, params);
}
//销量排行————渗透率
export const salesAnalysis = (params={}) => {
  const url = adminApi  + 'SalesRank/salesAnalysis'
  return http.fetchGet(url, params);
}
//销量排行——车系——车系型销量地区
export const getCityRank = (params={}) => {
  const url = adminApi  + 'SalesRank/cityRank'
  return http.fetchGet(url, params);
}
//销量排行————排行列表
export const salesRank = (params={}) => {
  const url = adminApi  + 'SalesRank/salesRank'
  return http.fetchGet(url, params);
}
//销量排行————日期渗透率
export const salesAnalysisByDate = (params={}) => {
  const url = adminApi  + 'SalesRank/salesAnalysisByDate'
  return http.fetchGet(url, params);
}

